module.exports = __webpack_public_path__ + "img/pic_502.f9731f69.png";